/**
 * prenotazione API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ResultEnum {

    InvalidInputErrors = 'INVALID_INPUT_ERRORS',

    ResourceNotFoundErrors = 'RESOURCE_NOT_FOUND_ERRORS',

    BadRequest = 'BAD_REQUEST',

    Conflict = 'CONFLICT',

    Forbidden = 'FORBIDDEN',

    GenericErrors = 'GENERIC_ERRORS',

    ReferencedError = 'REFERENCED_ERROR'
}

